import { Head, Link } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { InvoiceForm, type ClientOption, type CompanyOption, type PaymentTermOption } from "../../features/invoices/InvoiceForm"

type NewInvoiceProps = {
  invoice: {
    codigo_sap: string
    cr: string
    company_id: number | null
    client_id: number | null
    municipio: string
    ibge_codigo_municipio_prestacao?: string
    medicao: string
    periodo_inicio: string
    periodo_fim: string
    valor: string
    omie_servico_id?: number | null
    omie_conta_corrente_id?: number | null
    payment_term_id?: number | null
  }
  companies: CompanyOption[]
  clients: ClientOption[]
  payment_terms?: PaymentTermOption[]
  errors?: Record<string, string[]>
}

export default function NewInvoice({ invoice, companies, clients, payment_terms, errors }: NewInvoiceProps) {
  return (
    <>
      <Head title="Nova Nota Fiscal" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6 flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-white">Nova Nota Fiscal</h1>
              <p className="text-slate-400">Preencha os dados para cadastrar uma nova nota fiscal.</p>
            </div>
            <Link
              href="/notas-fiscais/emissao-em-massa"
              className="rounded-md border border-slate-700 bg-slate-900 px-4 py-2 text-sm font-medium text-slate-200 transition-colors hover:bg-slate-800"
            >
              Emissão em massa
            </Link>
          </div>
          <InvoiceForm
            initialValues={invoice}
            companies={companies}
            clients={clients}
            paymentTerms={payment_terms}
            submitUrl="/notas-fiscais"
            submitLabel="Criar nota fiscal"
            method="post"
            errors={errors}
          />
        </div>
      </AppLayout>
    </>
  )
}
